export default __webpack_public_path__ + "static/media/BELT DRIVE.7587b1af.jpg";